<template>
  <a-modal
    title="刪除公司"
    :visible="visible"
    :confirm-loading="loading"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <p>确定要删除这些公司吗？</p>
  </a-modal>
</template>

<script>
import { companyDelete } from '@/api/company'

export default {
  props: {
    selectedRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      noticeTitle: '公司管理',
      visible: false,
      loading: false
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleOk() {
      this.loading = true
      setTimeout(() => {
        if (this.visible) {
          const companyIds = this.selectedRows
            .map(item => {
              return item.id
            })
            .join(',')
          const param = {
            companyIds
          }
          companyDelete(param)
            .then(res => {
              if (res.success) {
                this.visible = false
                this.$notification.success({
                  message: this.noticeTitle,
                  description: '公司删除成功！'
                })
                this.$emit('reload')
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }, this.asyncTime)
    },
    handleCancel() {
      this.visible = false
      this.loading = false
    }
  }
}
</script>
